import React from "react";
import PropTypes from "prop-types";

function FeedLockIcon(props) {
  return (
    <svg width={props.size} height={props.size} viewBox="0 -960 960 960" fill="#ffffff">
      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm240-200q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z" />
    </svg>
  );
}

FeedLockIcon.propTypes = {
  size: PropTypes.number.isRequired,
};

export default FeedLockIcon;
